<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<span aria-label="iii" id="pg_iii" role="doc-pagebreak">
<figure class="IMG" id="tit"><img alt="24: Life Stories and Lessons from the Say Hey Kid by Willie Mays and John Shea" class="img90" src="images/title.jpg"/></figure>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6ea69275